<template>
  <form class="search" @submit.prevent="submit">
    <input
      ref="searchField"
      :value="value"
      class="search__field"
      type="text"
      name="search"
      :placeholder="placeholder || $t('Search')"
      @input="handleInput"
    />

    <button class="button-reset search__button" type="submit">
      <span>{{ $t('Find') }}</span>
      <SearchIcon :size="16" />
    </button>
  </form>
</template>

<script>
import { Search as SearchIcon } from 'lucide-vue'

export default {
  name: 'Search',
  components: {
    SearchIcon,
  },
  props: {
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    handleInput(evt) {
      this.$emit('input', evt.target.value)
    },
    submit() {
      this.$emit('submit', this.value)
    },
    focus() {
      this.$refs.searchField.focus()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.search {
  position: relative;
  display: flex;
  border-radius: 12px;
  background-color: $White;
  overflow: hidden;

  &__field {
    color: $Dark100;
    padding: 12px 16px;
    border-radius: 12px;
    font-size: 16px;
    background-color: $White;
    font-weight: 500;
    border: 1px solid transparent;
    outline: none;
    width: 100%;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    transition: border-color 200ms ease;

    &:focus {
      border-color: $LGray6;
    }

    &::placeholder {
      color: #737373;
      font-weight: 50;
    }

    @include media-breakpoint-down(xs) {
      padding: 10px 12px;
    }
  }

  .search__button {
    height: 100%;
    display: grid;
    grid-template-columns: auto 16px;
    column-gap: 6px;
    align-items: center;
    background-color: transparent;
    color: $GreenM;
    padding: 12px;
    font-size: 16px;
    font-weight: 400;
    border: none;
    transition: $transition ease color 0s;
  }
}
</style>
